/**
 * Legacy Vendor Entry Point
 * jQuery, Cookies, IScroll, Treeselect, and Loader are manually prepended.
 */

// 1. jQuery Plugins
import '../vendor/jquery/jquery-ui.js';
import '../vendor/jquery/plugins/jquery.cookie.js';
import '../vendor/jquery/plugins/jquery.scrollTo.min.js';
import '../vendor/jquery/plugins/jquery.expander.min.js';
import '../vendor/jquery/plugins/jquery.inputmask.min.js';

// 2. UI Frameworks
import '../vendor/bootstrap/bootstrap.bundle.min.js';

// 3. Other Vendors

import '../vendor/litepicker/litepicker.min.js';
// import '../vendor/search/uFuzzy.iife.js'; // Отключен - не используется
import '../vendor/search/fuse.min.js';
import '../vendor/utils/base64.js';
import '../vendor/utils/pako.min.js';

console.log('Vendor Bundle (Integrated Prepend v2) Loaded');
